import { render, staticRenderFns } from "./Divisions.vue?vue&type=template&id=a63ef8dc&scoped=true"
import script from "./Divisions.vue?vue&type=script&lang=js"
export * from "./Divisions.vue?vue&type=script&lang=js"
import style0 from "./Divisions.vue?vue&type=style&index=0&id=a63ef8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63ef8dc",
  null
  
)

export default component.exports